export const getUrlEnd = () => {
  const parts = window.location.pathname.split('/')

  return parts.pop()
}
